<template>
  <section>
    <ChooseAuditUser ref="chooseAudioUser" @change="handleAuditChange" :customShow="true" />
    <qx-card :noContent="true" title="基础资料审核" />
    <el-row style="display: flex;flex-flow: column wrap;height: 80vh">
      <el-col :span="12" v-for="(item, index) in auditList" :key="index" style="width:calc(100%/2)">
        <section class="auditBox posire">
          <section class="btnBox posiab">
            <span class="error cur delBtn" @click="remove(item)" v-show="item.auditNodes">清空</span>
            <el-button type="primary" plain @click="showUserDialog(item)">修改</el-button>
          </section>
          <p class="title">{{item.auditName}}</p>
          <p class="label">审核人员</p>
          <p class="user">{{handleShowUser(item)}}</p>
        </section>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import {
  baseApproveList,
  baseApproveEdit,
  baseApproveRemove,
} from 'api/system';
import ChooseAuditUser from 'components/chooseAuditUser/chooseAuditUser';
export default {
  components: {
    ChooseAuditUser,
  },
  data () {
    return {
      editData: {},
      auditList: [],
    };
  },
  methods: {
    showUserDialog (item) {
      this.editData = item;
      let data = [];
      if (item.auditNodes) {
        data = item.auditNodes[0].list.map((item) => ({
          linkman: item.userName,
          mobilePhone: item.userBill,
          userId: item.userId,
          orgNames: item.orgNames,
        }));
      }
      this.$refs.chooseAudioUser.show(data);
    },
    async handleAuditChange (result) {
      const targetObjId = result.map((item) => item.userId);
      const res = await baseApproveEdit({
        parentNodeId: this.editData.auditNodes ? this.editData.auditNodes[0].parentNodeId : -1,
        auditCode: this.editData.auditCode,
        nodeId: this.editData.auditNodes ? this.editData.auditNodes[0].nodeId : null,
        targetObjId: targetObjId.join(','),
        targetObjType: 2,
      });
      if (!res.failed) {
        this.$message.success('修改成功');
        this.getData();
      }
    },
    async remove (item) {
      const confirmRes = await this.$confirm('确认要清空所有审核人员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await baseApproveRemove({
          nodeId: item.auditNodes[0].nodeId,
        });
        if (!res.failed) {
          this.$message.success('移除成功');
          this.getData();
        }
      }
    },
    handleShowUser (item) {
      if (item.auditNodes) {
        const arrUser = item.auditNodes[0].list.map((item) => item.userName);
        return arrUser.join('，');
      } else {
        return '--';
      }
    },
    async getData () {
      const res = await baseApproveList();
      this.auditList = Array.isArray(res) ? res : (Array.isArray(res && res.items) ? res.items : []);
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.auditBox {
  border-radius: 8px;
  background: #fff;
  padding: 0 12px 24px;
  box-sizing: border-box;
  margin: 4px;
  .btnBox {
    top: 12px;
    right: 24px;
    .delBtn {
      margin-right: 16px;
    }
  }
  .title {
    height: 40px;
    line-height: 40px;
    margin-bottom: 8px;
    color: #333;
  }
  .label {
    height: 14px;
    line-height: 14px;
    margin-bottom: 16px;
    color: #666;
  }
  //.user {
  //  color: #333;
  //  height: 14px;
  //  line-height: 14px;
  //}
}
</style>
